import React, { useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Text, TextInput } from "evergreen-ui";
import { Select } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

function randomInteger(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}
const db = getDatabase(Firebase);

const ZoneActionLayout = (props) => {
	const [name, setName] = useState("");
	const [code, setCode] = useState("");
	const [selectedCountry, setSelectedCountry] = useState(null);
	const [countries] = useListVals(ref(db, "talmidsdb/countries"));

	const handleCreate = () => {
		if (!name) {
			alert("Please enter a zone name");
			return;
		}

		if (name.includes("/")) {
			alert("The name cannot include a slash, use a dash or another symbol instead");
			return;
		}

		if (!selectedCountry) {
			alert("Please select a country");
			return;
		}
		const number = randomInteger(10000, 20000);
		const objectID = uuidv4();
		const object = {
			zone: name,
			id: objectID,
			code: code,
			countryID: selectedCountry
		};
		props.createCallback("zones", objectID, object);
		console.log(object);
		setName("");
		setCode("");
		setSelectedCountry(null);
	};

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol>
					<div className="d-flex flex-column">
						<div className="d-flex flex-column my-2">
							<Text className="mb-1">Select Country</Text>
							<Select
								placeholder="Select Country"
								showSearch
								optionFilterProp="children"
								value={selectedCountry}
								onChange={(value) => setSelectedCountry(value)}
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}
								loading={!countries}
							>
								{countries?.map((country) => (
									<Select.Option value={country.id} key={country.id}>
										{country.countryName}
									</Select.Option>
								))}
							</Select>
						</div>
						<div className="d-flex flex-column my-2">
							<Text className="mb-1">Enter Zone Name</Text>
							<TextInput
								className="w-100"
								name="text-input-name"
								placeholder="Enter zone name"
								onChange={(e) => setName(e.target.value)}
								value={name}
							/>
						</div>
						<div className="d-flex flex-column my-2">
							<Text className="mb-1">Enter Zone Code</Text>
							<TextInput
								className="w-100"
								name="text-input-code"
								placeholder="Enter zone code"
								onChange={(e) => setCode(e.target.value)}
								value={code}
							/>
						</div>
					</div>
					<Button
						appearance="primary"
						className="mt-2"
						onClick={handleCreate}
						disabled={!selectedCountry || !name}
					>
						Add
					</Button>
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default ZoneActionLayout;